__turbopack_context__.v({
  "Root": "_hC27q_Root",
  "skeleton-loading": "_hC27q_skeleton-loading",
});
